module.exports = __webpack_public_path__ + "static/merfolk-3087aa11f274bc30b013741948de4085.jpeg";